<div class="aa-input-general gap-1 flex flex-col">
  <mat-label
    class="px-3 truncate"
    [title]="label | translate"
    [ngClass]="
      formControlGeneral?.invalid && (formControlGeneral?.touched || formControlGeneral?.dirty)
        ? 'text-(--comp-input-label-error)'
        : 'text-(--comp-input-label-normal)'
    "
  >
    {{ isRequired(formControlGeneral) ? (label | translate) + '*' : (label | translate) }}
  </mat-label>

  <mat-form-field appearance="outline" class="w-full input-mat-form-field">
    <input
      [formControl]="getInputGeneral"
      placeholder="DD/MM/AAA"
      matInput
      [placeholder]="placeholder | translate"
      [matDatepicker]="datepicker"
      [min]="min"
    />
    @if (formControlGeneral!.hasError('required')) {
      <mat-error>{{ 'inputs.required' | translate }}</mat-error>
    }
    @if (formControlGeneral!.errors && formControlGeneral!.errors['errorGeneral']) {
      <mat-error>
        {{ formControlGeneral!.errors['errorGeneral'] }}
      </mat-error>
    }
    <mat-datepicker-toggle matIconSuffix [for]="datepicker"></mat-datepicker-toggle>
    <mat-datepicker #datepicker> </mat-datepicker>
  </mat-form-field>
</div>
